// This file is auto-generated by /tools/figma-color-sync/generate-color-definitions.js
// do not modify manually

export const generatedCtxColorTokens = {
    ctxGray: {
        '100': '#fcfcfc',
        '200': '#efefef',
        '300': '#dcdcdc',
        '400': '#d1d1d1',
        '500': '#b0b0b0',
        '600': '#757575',
        '700': '#6b6b6b',
        '900': '#323232',
    },
    ctxSecondary: {
        '400': '#f4e01b',
        '500': '#ffdd00',
    },
    ctxNeutral: {
        '0': '#ffffff',
        '100': '#f7f8f9',
        '200': '#ebedf0',
        '300': '#dee2e6',
        '400': '#d1d5db',
        '500': '#bcc3cd',
        '600': '#818ea1',
        '700': '#6b7280',
        '900': '#4b5563',
    },
    ctxPrimary: {
        '50': '#f0f7ff',
        '100': '#dfeeff',
        '200': '#bcddfb',
        '300': '#89c2f0',
        '400': '#3fa4f1',
        '500': '#0f89e8',
        '600': '#006bcb',
        '700': '#00529e',
        '800': '#054a87',
        '900': '#0a3d70',
        '950': '#07274a',
    },
    ctxStatusDanger: {
        '50': '#fef6f6',
        '100': '#fde3e3',
        '300': '#f8a9a9',
        '400': '#f27777',
        '500': '#e84b4b',
        '700': '#c62828',
    },
    ctxStatusInfo: {
        '100': '#e1effd',
        '500': '#138be4',
        '700': '#065193',
    },
    ctxStatusNeutral: {
        '100': '#edeef1',
        '700': '#556376',
    },
    ctxStatusSuccess: {
        '50': '#f5faf5',
        '100': '#e5f3e5',
        '300': '#16a216',
        '500': '#509751',
        '600': '#3f7e3f',
        '700': '#315e32',
    },
    ctxStatusHelp: {
        '50': '#faf6fe',
        '100': '#f3e8fd',
        '300': '#a855f7',
        '500': '#9333ea',
        '700': '#7e22ce',
    },
    ctxStatusWarning: {
        '50': '#fdf7ef',
        '100': '#fbecd9',
        '300': '#f1bb80',
        '400': '#ea954d',
        '500': '#e5782a',
        '600': '#d75f1f',
        '700': '#a7441a',
    },
};
